// get_ai_prompt_types
export const GET_AI_PROMPT_TYPE = 'get_ai_prompt_types';
export const GET_AI_PROMPT_TYPE_SUCCESSFUL = 'get_ai_prompt_types_successfull';
export const GET_AI_PROMPT_TYPE_FAILED = 'get_ai_prompt_types_failed';

// create_ai_prompt_type
export const CREATE_AI_PROMPT_TYPE = 'create_ai_prompt_type';
export const CREATE_AI_PROMPT_TYPE_SUCCESSFUL =
  'create_ai_prompt_type_successfull';
export const CREATE_AI_PROMPT_TYPE_FAILED = 'create_ai_prompt_type_failed';

// update_ai_prompt_type
export const UPDATE_AI_PROMPT_TYPE = 'update_ai_prompt_type';
export const UPDATE_AI_PROMPT_TYPE_SUCCESSFUL =
  'update_ai_prompt_type_successfull';
export const UPDATE_AI_PROMPT_TYPE_FAILED = 'update_ai_prompt_type_failed';

// delete_ai_prompt_type
export const DELETE_AI_PROMPT_TYPE = 'delete_ai_prompt_type';
export const DELETE_AI_PROMPT_TYPE_SUCCESSFUL =
  'delete_ai_prompt_type_successfull';
export const DELETE_AI_PROMPT_TYPE_FAILED = 'delete_ai_prompt_type_failed';
